import React, { useContext, useRef, useState, useEffect } from "react";
import { AuthContext } from "../context/auth";
import { useForm } from "../util/hooks";
import { Mensaje } from "../components/mensajes";

//import '../login.css';
import "../main.css";
import "../normalize.css";
import axios from "axios";
import { Dimmer } from "../components/spinner";
import moment from "moment";

function Login(props) {
  let op = require("../../src/modulos/datos");
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const txtUserName = useRef(null);
  const txtPassword = useRef(null);
  const context = useContext(AuthContext);
  const [pass, setPass] = useState("");
  const [mask, setMask] = useState("*");

  /*const { onChange, onSubmit, values } = useForm(loginUserCallback, {
    username: '',
    password: ''
  });*/

  useEffect(() => {
    // Al entrar al login se cierra cualquier sesión previa y se limpian
    // los campos para que no queden usuario ni clave grabados.
    context.logout();
    if (txtUserName.current) txtUserName.current.value = "";
    setPass("");
  }, []);

  const { onSubmit } = useForm(loginUserCallback);

  const cargarIpMac = () => {
    let endpoint = op.servidor + "/ipmac.php";

    console.log(endpoint);

    axios
      .get(endpoint)
      .then(function (response) {
        if (response.status == 200) {
          localStorage.setItem("ip", JSON.stringify(response.data.ip || "000"));
          localStorage.setItem(
            "mac",
            JSON.stringify(response.data.mac || "000"),
          );
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const datosEfis1 = () => {
    let endpoint = op.conexion + "/api/comun/ultimoejercicio";

    axios
      .get(endpoint)
      .then(function (response) {
        if (response.status === 200) {
          /*     setDatosEfis(response.data); */

          console.log(response.data);
          localStorage.setItem("idefiscal", response.data.idefiscal);
          localStorage.setItem("efiscaldes", response.data.descriptor);
          localStorage.setItem("efiscalanio", response.data.anio);
          localStorage.setItem("idorganizacion", response.data.idorganizacion);
          localStorage.setItem("efiseleccionado", true);
          if (op.nombre === "aguablancahac") {
            props.history.push("/haciendaMunicipal");
          } else {
            props.history.push("/inicio");
          }
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg("Notificacion", error.response.data.message, "error", "Aceptar");
        setMostrar(true);
      });
  };

  const sinIgn = async () => {
    let endpoint = op.conexion + "/api/auth/signin";

    /*var login = values.username;
    var passwd = values.password;*/
    var login = txtUserName.current.value;
    var passwd = pass;

    axios
      .post(endpoint, {
        login: login,
        passwd: passwd,
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(
            " ------------   mira liquidador  ----------------->" +
            response.data.respuesta.liquidador,
          );

          context.login(response.data.token);
          if (response.data.token === null) {
            props.history.push("/");
          } else {
            buscarFactorCambio();
            buscarValordolar();
            console.log("permiso: " + response.data.permisos.accconfigene);

            (localStorage.setItem(
              "idusuario",
              JSON.stringify(response.data.respuesta.idusuario),
            ),
              localStorage.setItem(
                "liquidador",
                JSON.stringify(response.data.respuesta.liquidador),
              ),
              localStorage.setItem(
                "fechasistema",
                JSON.stringify(response.data.respuesta.fechasistema),
              ),
              localStorage.setItem(
                "fechareal",
                JSON.stringify(response.data.respuesta.fechasistema),
              ),
              localStorage.setItem(
                "espiritu",
                JSON.stringify(response.data.respuesta.espiritu),
              ),
              localStorage.setItem("efiseleccionado", false),
              localStorage.setItem("idefiscal", JSON.stringify("")));
            localStorage.setItem("efiscaldes", JSON.stringify(""));
            localStorage.setItem("efiscalanio", JSON.stringify(""));
            localStorage.setItem("statuspresup", JSON.stringify(""));
            localStorage.setItem("statuspuc", JSON.stringify(""));
            localStorage.setItem("statuscat", JSON.stringify(""));
            localStorage.setItem("statusorg", JSON.stringify(""));
            localStorage.setItem(
              "anioactu",
              JSON.stringify(
                new Date(response.data.respuesta.fechasistema).getFullYear(),
              ),
            );
            localStorage.setItem(
              "persona",
              JSON.stringify(response.data.respuesta.persona),
            );
            localStorage.setItem(
              "riforg",
              JSON.stringify(response.data.respuesta.riforg),
            );
            localStorage.setItem(
              "idproveedor",
              JSON.stringify(response.data.respuesta.idproveedor),
            );
            localStorage.setItem(
              "post",
              JSON.stringify(response.data.respuesta),
            );
            localStorage.setItem(
              "numcaja",
              JSON.stringify(response.data.respuesta.numcaja),
            );
            localStorage.setItem(
              "permisos",
              JSON.stringify(response.data.permisos),
            );
            localStorage.setItem(
              "accaplicacion",
              JSON.stringify(response.data.permisos.accaplicacion),
            );
            localStorage.setItem(
              "accestructura",
              JSON.stringify(response.data.permisos.accestructura),
            );
            localStorage.setItem(
              "accorganizacion",
              JSON.stringify(response.data.permisos.accorganizacion),
            );
            localStorage.setItem(
              "accusuario",
              JSON.stringify(response.data.permisos.accusuario),
            );
            localStorage.setItem(
              "accpersona",
              JSON.stringify(response.data.permisos.accpersona),
            );

            localStorage.setItem(
              "acciva",
              JSON.stringify(response.data.permisos.acciva),
            );
            localStorage.setItem(
              "accut",
              JSON.stringify(response.data.permisos.accut),
            );
            localStorage.setItem(
              "acctasaactiva",
              JSON.stringify(response.data.permisos.acctasaactiva),
            );
            localStorage.setItem(
              "acctasapasiva",
              JSON.stringify(response.data.permisos.acctasapasiva),
            );
            localStorage.setItem(
              "acccambiofecha",
              JSON.stringify(response.data.permisos.acccambiofecha),
            );
            localStorage.setItem(
              "acccambioefiscal",
              JSON.stringify(response.data.permisos.acccambioefiscal),
            );

            /*inicio permisos catastro */
            localStorage.setItem(
              "accrepvalterreno",
              JSON.stringify(response.data.permisos.accrepvalterreno),
            );
            localStorage.setItem(
              "accrepdepreciacion",
              JSON.stringify(response.data.permisos.accrepdepreciacion),
            );
            localStorage.setItem(
              "accrepgenseccat",
              JSON.stringify(response.data.permisos.accrepgenseccat),
            );
            localStorage.setItem(
              "accrepconstancia",
              JSON.stringify(response.data.permisos.accrepconstancia),
            );
            localStorage.setItem(
              "accrepvalconstruc",
              JSON.stringify(response.data.permisos.accrepvalconstruc),
            );
            localStorage.setItem(
              "acccamstainmue",
              JSON.stringify(response.data.permisos.acccamstainmue),
            );
            localStorage.setItem(
              "accrepcedcat",
              JSON.stringify(response.data.permisos.accrepcedcat),
            );
            localStorage.setItem(
              "accrepceremp",
              JSON.stringify(response.data.permisos.accrepceremp),
            );
            localStorage.setItem(
              "accfichacat",
              JSON.stringify(response.data.permisos.accfichacat),
            );
            localStorage.setItem(
              "accvalorterrecat",
              JSON.stringify(response.data.permisos.accvalorterrecat),
            );
            localStorage.setItem(
              "accdepreciacioncat",
              JSON.stringify(response.data.permisos.accdepreciacioncat),
            );
            localStorage.setItem(
              "accavaluo",
              JSON.stringify(response.data.permisos.accavaluo),
            );
            localStorage.setItem(
              "accusuariocat",
              JSON.stringify(response.data.permisos.accusuariocat),
            );
            localStorage.setItem(
              "supercat",
              JSON.stringify(response.data.permisos.supercat),
            );
            localStorage.setItem(
              "accvalortipocat",
              JSON.stringify(response.data.permisos.accvalortipocat),
            );
            /* fin permisos catastro */

            /*inicio permisos acrividad economica */
            localStorage.setItem(
              "accdeclaraciones",
              JSON.stringify(response.data.permisos.accdeclaraciones),
            );
            localStorage.setItem(
              "accedocuenta",
              JSON.stringify(response.data.permisos.accedocuenta),
            );
            localStorage.setItem(
              "accexoncomercio",
              JSON.stringify(response.data.permisos.accexoncomercio),
            );
            localStorage.setItem(
              "accconfigcome",
              JSON.stringify(response.data.permisos.accconfigcome),
            );
            localStorage.setItem(
              "acccontribuyente",
              JSON.stringify(response.data.permisos.acccontribuyente),
            );
            localStorage.setItem(
              "accactividad",
              JSON.stringify(response.data.permisos.accactividad),
            );
            localStorage.setItem(
              "accusuariocome",
              JSON.stringify(response.data.permisos.accusuariocome),
            );
            localStorage.setItem(
              "accagente",
              JSON.stringify(response.data.permisos.accagente),
            );
            localStorage.setItem(
              "accreppatente",
              JSON.stringify(response.data.permisos.accreppatente),
            );
            localStorage.setItem(
              "accrepgensector",
              JSON.stringify(response.data.permisos.accrepgensector),
            );
            localStorage.setItem(
              "accrepactividad",
              JSON.stringify(response.data.permisos.accrepactividad),
            );
            localStorage.setItem(
              "accrepfecdecla",
              JSON.stringify(response.data.permisos.accrepfecdecla),
            );
            localStorage.setItem(
              "accrepmondecla",
              JSON.stringify(response.data.permisos.accrepmondecla),
            );
            localStorage.setItem(
              "accimppatente",
              JSON.stringify(response.data.permisos.accimppatente),
            );
            localStorage.setItem(
              "accimpedoctasectcome",
              JSON.stringify(response.data.permisos.accimpedoctasectcome),
            );
            localStorage.setItem(
              "accimptramites",
              JSON.stringify(response.data.permisos.accimptramites),
            );
            localStorage.setItem(
              "accpermdecla",
              JSON.stringify(response.data.permisos.accpermdecla),
            );
            localStorage.setItem(
              "accacreditacion",
              JSON.stringify(response.data.permisos.accacreditacion),
            );
            localStorage.setItem(
              "accrenovalicencia",
              JSON.stringify(response.data.permisos.accrenovalicencia),
            );
            localStorage.setItem(
              "acclicenciafunciona",
              JSON.stringify(response.data.permisos.acclicenciafunciona),
            );
            //  localStorage.setItem('liquidador', JSON.stringify(response.data.permisos.liquidador))
            localStorage.setItem(
              "accacticontri",
              JSON.stringify(response.data.permisos.accacticontri),
            );

            /* fin permisos acrividad economica */

            /* inicio permiso inmueble */
            localStorage.setItem(
              "accusrepmontaval",
              JSON.stringify(response.data.permisos.accusrepmontaval),
            );
            localStorage.setItem(
              "accedocuenta",
              JSON.stringify(response.data.permisos.accedocuenta),
            );
            localStorage.setItem(
              "accusrepsectcat",
              JSON.stringify(response.data.permisos.accusrepsectcat),
            );
            localStorage.setItem(
              "accusreptipconstruc",
              JSON.stringify(response.data.permisos.accusreptipconstruc),
            );
            localStorage.setItem(
              "accusrepmontdeud",
              JSON.stringify(response.data.permisos.accusrepmontdeud),
            );
            localStorage.setItem(
              "accusrepvalorconstruc",
              JSON.stringify(response.data.permisos.accusrepvalorconstruc),
            );
            localStorage.setItem(
              "accimpedoctasectinmue",
              JSON.stringify(response.data.permisos.accimpedoctasectinmue),
            );
            localStorage.setItem(
              "accperespinmue",
              JSON.stringify(response.data.permisos.accperespinmue),
            );
            localStorage.setItem(
              "accconfiginmue",
              JSON.stringify(response.data.permisos.accconfiginmue),
            );
            localStorage.setItem(
              "accvincuusoterre",
              JSON.stringify(response.data.permisos.accvincuusoterre),
            );

            localStorage.setItem(
              "accinmueble",
              JSON.stringify(response.data.permisos.accinmueble),
            );
            localStorage.setItem(
              "accvalfiscons",
              JSON.stringify(response.data.permisos.accvalfiscons),
            );
            localStorage.setItem(
              "accusuarioinmue",
              JSON.stringify(response.data.permisos.accusuarioinmue),
            );
            /* fin permiso inmueble */

            /* inicio permisos vehiculo */
            localStorage.setItem(
              "accedoctavehiculo",
              JSON.stringify(response.data.permisos.accusrepmontaval),
            );
            localStorage.setItem(
              "accconfigvehiculo",
              JSON.stringify(response.data.permisos.accconfigvehiculo),
            );
            localStorage.setItem(
              "accrepgenvehi",
              JSON.stringify(response.data.permisos.accrepgenvehi),
            );
            localStorage.setItem(
              "accrepcontvehideud",
              JSON.stringify(response.data.permisos.accrepcontvehideud),
            );
            localStorage.setItem(
              "accreptipvehi",
              JSON.stringify(response.data.permisos.accreptipvehi),
            );
            localStorage.setItem(
              "accvehiculo",
              JSON.stringify(response.data.permisos.accvehiculo),
            );
            localStorage.setItem(
              "accclasevehiculo",
              JSON.stringify(response.data.permisos.accclasevehiculo),
            );
            localStorage.setItem(
              "accusuariovehiculo",
              JSON.stringify(response.data.permisos.accusuariovehiculo),
            );

            /* fin permiso vehiculo */

            /* inicio permisos publicidad */
            localStorage.setItem(
              "accedoctapublicidad",
              JSON.stringify(response.data.permisos.accedoctapublicidad),
            );
            localStorage.setItem(
              "accstatuspubli",
              JSON.stringify(response.data.permisos.accstatuspubli),
            );

            localStorage.setItem(
              "accconfigpublicidad",
              JSON.stringify(response.data.permisos.accconfigpublicidad),
            );
            localStorage.setItem(
              "accrepgensecpubli",
              JSON.stringify(response.data.permisos.accrepgensecpubli),
            );
            localStorage.setItem(
              "accrepcontpublideud",
              JSON.stringify(response.data.permisos.accrepcontpublideud),
            );
            localStorage.setItem(
              "accreptippubli",
              JSON.stringify(response.data.permisos.accreptippubli),
            );
            localStorage.setItem(
              "accrepedoctapubli",
              JSON.stringify(response.data.permisos.accrepedoctapubli),
            );
            localStorage.setItem(
              "accpublicidad",
              JSON.stringify(response.data.permisos.accpublicidad),
            );
            localStorage.setItem(
              "accclasepublicidad",
              JSON.stringify(response.data.permisos.accclasepublicidad),
            );
            localStorage.setItem(
              "accusuariopublicidad",
              JSON.stringify(response.data.permisos.accusuariopublicidad),
            );

            /* fin permiso publicidad */

            /* inicio permiso renta inmobiliaria */
            localStorage.setItem(
              "accedoctarenta",
              JSON.stringify(response.data.permisos.accedoctarenta),
            );
            localStorage.setItem(
              "accconfigrenta",
              JSON.stringify(response.data.permisos.accconfigrenta),
            );
            localStorage.setItem(
              "accrepgenrenta",
              JSON.stringify(response.data.permisos.accrepgenrenta),
            );
            localStorage.setItem(
              "accurepcontratorenta",
              JSON.stringify(response.data.permisos.accurepcontratorenta),
            );
            localStorage.setItem(
              "accrepdeudarenta",
              JSON.stringify(response.data.permisos.accrepdeudarenta),
            );
            localStorage.setItem(
              "accrepedoctarenta",
              JSON.stringify(response.data.permisos.accrepedoctarenta),
            );
            localStorage.setItem(
              "accreptiporenta",
              JSON.stringify(response.data.permisos.accreptiporenta),
            );
            localStorage.setItem(
              "accrenta",
              JSON.stringify(response.data.permisos.accrenta),
            );
            localStorage.setItem(
              "acctiporenta",
              JSON.stringify(response.data.permisos.acctiporenta),
            );
            localStorage.setItem(
              "accusuariorenta",
              JSON.stringify(response.data.permisos.accusuariorenta),
            );

            /* fin permiso renta inmobiliaria */

            /*inicio permisos de presupuesto */
            localStorage.setItem(
              "acccatpro",
              JSON.stringify(response.data.permisos.acccatpro),
            );
            localStorage.setItem(
              "accpuc",
              JSON.stringify(response.data.permisos.accpuc),
            );
            localStorage.setItem(
              "accactivos",
              JSON.stringify(response.data.permisos.accactivos),
            );
            localStorage.setItem(
              "acccargos",
              JSON.stringify(response.data.permisos.acccargos),
            );
            localStorage.setItem(
              "superpresu",
              JSON.stringify(response.data.permisos.superpresu),
            );
            localStorage.setItem(
              "accpartext",
              JSON.stringify(response.data.permisos.accpartext),
            );
            localStorage.setItem(
              "accrepedofinanc",
              JSON.stringify(response.data.permisos.accrepedofinanc),
            );
            localStorage.setItem(
              "accrepcondicpar",
              JSON.stringify(response.data.permisos.accrepcondicpar),
            );
            localStorage.setItem(
              "accrepmovpresu",
              JSON.stringify(response.data.permisos.accrepmovpresu),
            );
            localStorage.setItem(
              "accrepcomprom",
              JSON.stringify(response.data.permisos.accrepcomprom),
            );
            localStorage.setItem(
              "accformpresu",
              JSON.stringify(response.data.permisos.accformpresu),
            );
            localStorage.setItem(
              "accaprobpresup",
              JSON.stringify(response.data.permisos.accaprobpresup),
            );
            localStorage.setItem(
              "accreppresuing",
              JSON.stringify(response.data.permisos.accreppresuing),
            );
            localStorage.setItem(
              "accaumentopart",
              JSON.stringify(response.data.permisos.accaumentopart),
            );
            localStorage.setItem(
              "accdisminucionpart",
              JSON.stringify(response.data.permisos.accdisminucionpart),
            );
            localStorage.setItem(
              "acctraslado",
              JSON.stringify(response.data.permisos.acctraslado),
            );
            localStorage.setItem(
              "acccompromiso",
              JSON.stringify(response.data.permisos.acccompromiso),
            );
            localStorage.setItem(
              "accaprocompro",
              JSON.stringify(response.data.permisos.accaprocompro),
            );
            localStorage.setItem(
              "accreppuc",
              JSON.stringify(response.data.permisos.accreppuc),
            );
            localStorage.setItem(
              "accrepformpresu",
              JSON.stringify(response.data.permisos.accrepformpresu),
            );
            localStorage.setItem(
              "acccontribuyente",
              JSON.stringify(response.data.permisos.acccontribuyente),
            );
            localStorage.setItem(
              "accefiscal",
              JSON.stringify(response.data.permisos.accefiscal),
            );
            localStorage.setItem(
              "accusuariopresu",
              JSON.stringify(response.data.permisos.accusuariopresu),
            );

            /* fin permisos de presupuesto */

            /*inicio permisos de administracion */
            localStorage.setItem(
              "superadmin",
              JSON.stringify(response.data.permisos.superadmin),
            );
            localStorage.setItem(
              "clavesuperadmin",
              JSON.stringify(response.data.permisos.clavesuperadmin),
            );
            localStorage.setItem(
              "superteso",
              JSON.stringify(response.data.permisos.superteso),
            );
            localStorage.setItem(
              "clavesuperteso",
              JSON.stringify(response.data.permisos.clavesuperteso),
            );

            localStorage.setItem(
              "accrereversegreso",
              JSON.stringify(response.data.permisos.accrereversegreso),
            );
            localStorage.setItem(
              "accdebito",
              JSON.stringify(response.data.permisos.accdebito),
            );
            localStorage.setItem(
              "accingresos",
              JSON.stringify(response.data.permisos.accingresos),
            );
            localStorage.setItem(
              "accaproborden",
              JSON.stringify(response.data.permisos.accaproborden),
            );
            localStorage.setItem(
              "accrepobras",
              JSON.stringify(response.data.permisos.accrepobras),
            );
            localStorage.setItem(
              "accmodreten",
              JSON.stringify(response.data.permisos.accmodreten),
            );
            localStorage.setItem(
              "accenvchecausar",
              JSON.stringify(response.data.permisos.accenvchecausar),
            );
            localStorage.setItem(
              "accfondotercero",
              JSON.stringify(response.data.permisos.accfondotercero),
            );
            localStorage.setItem(
              "acccausar",
              JSON.stringify(response.data.permisos.acccausar),
            );
            localStorage.setItem(
              "acccambioefiscal",
              JSON.stringify(response.data.permisos.acccambioefiscal),
            );
            localStorage.setItem(
              "acccredito",
              JSON.stringify(response.data.permisos.acccredito),
            );
            localStorage.setItem(
              "accpagoordenes",
              JSON.stringify(response.data.permisos.accpagoordenes),
            );
            localStorage.setItem(
              "acccontrolinterno",
              JSON.stringify(response.data.permisos.acccontrolinterno),
            );
            localStorage.setItem(
              "accespecial",
              JSON.stringify(response.data.permisos.accespecial),
            );
            localStorage.setItem(
              "accadministrador",
              JSON.stringify(response.data.permisos.accadministrador),
            );
            localStorage.setItem(
              "accrereversordenpago",
              JSON.stringify(response.data.permisos.accrereversordenpago),
            );
            localStorage.setItem(
              "accrepordenpago",
              JSON.stringify(response.data.permisos.accrepordenpago),
            );
            localStorage.setItem(
              "accrepbanco",
              JSON.stringify(response.data.permisos.accrepbanco),
            );
            localStorage.setItem(
              "accrepretencion",
              JSON.stringify(response.data.permisos.accrepretencion),
            );
            localStorage.setItem(
              "accrepfondoterc",
              JSON.stringify(response.data.permisos.accrepfondoterc),
            );
            localStorage.setItem(
              "accegresos",
              JSON.stringify(response.data.permisos.accegresos),
            );
            localStorage.setItem(
              "accdeposito",
              JSON.stringify(response.data.permisos.accdeposito),
            );
            localStorage.setItem(
              "acctransferenciabanc",
              JSON.stringify(response.data.permisos.acctransferenciabanc),
            );
            localStorage.setItem(
              "accrereverspagar",
              JSON.stringify(response.data.permisos.accrereverspagar),
            );
            localStorage.setItem(
              "accconciliacion",
              JSON.stringify(response.data.permisos.accconciliacion),
            );
            localStorage.setItem(
              "acccheqanul",
              JSON.stringify(response.data.permisos.acccheqanul),
            );
            localStorage.setItem(
              "accrereversdeposito",
              JSON.stringify(response.data.permisos.accrereversdeposito),
            );
            localStorage.setItem(
              "accbanco",
              JSON.stringify(response.data.permisos.accbanco),
            );
            localStorage.setItem(
              "acccuentabancaria",
              JSON.stringify(response.data.permisos.acccuentabancaria),
            );
            localStorage.setItem(
              "accdeclaraciones",
              JSON.stringify(response.data.permisos.accdeclaraciones),
            );
            localStorage.setItem(
              "accacticontri",
              JSON.stringify(response.data.permisos.accacticontri),
            );
            localStorage.setItem(
              "acctiporetencion",
              JSON.stringify(response.data.permisos.acctiporetencion),
            );
            localStorage.setItem(
              "accusuarioadmini",
              JSON.stringify(response.data.permisos.accusuarioadmini),
            );
            localStorage.setItem(
              "acctipoingreso",
              JSON.stringify(response.data.permisos.acctipoingreso),
            );
            localStorage.setItem(
              "accmovtransito",
              JSON.stringify(response.data.permisos.accmovtransito),
            );

            /* fin permisos de administracion */

            /* inicio de los permisos de compra */
            localStorage.setItem(
              "accaprosolicompra",
              JSON.stringify(response.data.permisos.accaprosolicompra),
            );
            localStorage.setItem(
              "acclisgencompraalmacen",
              JSON.stringify(response.data.permisos.acclisgencompraalmacen),
            );
            localStorage.setItem(
              "acclissolicompraalmacen",
              JSON.stringify(response.data.permisos.acclissolicompraalmacen),
            );
            localStorage.setItem(
              "accproveedor",
              JSON.stringify(response.data.permisos.accproveedor),
            );
            localStorage.setItem(
              "accunimedi",
              JSON.stringify(response.data.permisos.accunimedi),
            );
            localStorage.setItem(
              "acctipoproducto",
              JSON.stringify(response.data.permisos.acctipoproducto),
            );
            localStorage.setItem(
              "accproducto",
              JSON.stringify(response.data.permisos.accproducto),
            );

            localStorage.setItem(
              "accrequisicion",
              JSON.stringify(response.data.permisos.accrequisicion),
            );
            localStorage.setItem(
              "accsolicompra",
              JSON.stringify(response.data.permisos.accsolicompra),
            );

            localStorage.setItem(
              "accusuariocompra",
              JSON.stringify(response.data.permisos.accusuariocompra),
            );

            /* fin de los permisos de compra */

            /*inicio permisos de Gestion Comercial */
            localStorage.setItem(
              "accactudeuapuesta",
              JSON.stringify(response.data.permisos.accactudeuapuesta),
            );
            localStorage.setItem(
              "accactudeuindustria",
              JSON.stringify(response.data.permisos.accactudeuindustria),
            );
            localStorage.setItem(
              "accactudeuinmue",
              JSON.stringify(response.data.permisos.accactudeuinmue),
            );
            localStorage.setItem(
              "accactudeurenta",
              JSON.stringify(response.data.permisos.accactudeurenta),
            );
            localStorage.setItem(
              "accactudeuvehiculo",
              JSON.stringify(response.data.permisos.accactudeuvehiculo),
            );

            /* fin de los permisos de Gestion Comercial */

            /*inicio permisos de Contabilidad Fiscal */
            localStorage.setItem(
              "accreptransdiarias",
              JSON.stringify(response.data.permisos.accreptransdiarias),
            );


            /* fin de los permisos de Contabilidad Fiscal */

            /* impresora */
            localStorage.setItem(
              "impresora",
              JSON.stringify(response.data.respuesta.impresora),
            );
            localStorage.setItem(
              "nameprint",
              JSON.stringify(response.data.respuesta.nameprint),
            );

            /* impresora */
            console.log(
              "------------------------------ permisos ------------------------------",
            );
            console.log(response.data.permisos);
            console.log(
              "------------------------------ permisos ------------------------------",
            );

            datosEfis1();
          }
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
      })
      .finally(function () {
        setLoading(false);
      });
  };

  function loginUserCallback() {
    sinIgn();
    cargarIpMac();
    setLoading(true);
    limpiarCampos();
  }

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  // Limpia los campos del formulario de login.
  const limpiarCampos = () => {
    if (txtUserName.current) txtUserName.current.value = "";
    setPass("");
  };

  const updatePass = (e) => {
    let newValue = e.target.value;
    let newLength = newValue.length / mask.length;
    let oldLength = pass.length * mask.length;

    if (pass.length < newLength) {
      setPass(pass + newValue.slice(oldLength));
    }

    if (pass.length > newLength) {
      setPass(pass.slice(0, newLength));
    }
  };
  const buscarFactorCambio = async () => {
    try {
      const endpoint = `${op.conexion}/api/vehiculo/factorcambio`;
      const response = await axios.get(endpoint);
      localStorage.setItem("factorCambio", JSON.stringify(response.data));
    } catch (error) {
      console.error(error);

    }
  };
  const buscarValordolar = async () => {
    try {
      const campos = "*";
      const tabla = "monedadetalle";
      const orden = `1=1`;
      const condi = `fecha::date='${moment(new Date()).format("YYYY-MM-DD")}'`;
      const endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${tabla}&condi=${condi}&orden=${orden}`;
      const response = await axios.get(endpoint);
      let valor = 1
      if (response.status === 200 && response.data && response.data.length > 0) {
        valor = parseFloat(response.data[0].valor).toFixed(2)
      }
      localStorage.setItem("valorDolar", JSON.stringify(valor));
    } catch (error) {
      console.error(error);
    }
  };
  return (
    /*  <main className="login-design"> */
    <main className="limiter p-0">
      <div class="container-login100">
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), 
                      linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
            backgroundSize: "50px 50px",
            pointerEvents: "none", // Esta línea soluciona el problema
          }}
        />
        <div class="wrap-login100" style={{}}>
          <div class="login100-pic js-tilt" data-tilt>
            <img src={op.imagenes + "/imagen?img=Logopsiap2.png"} alt="IMG" />
            <span class="login200-form-title">
              SISTEMA INTEGRAL PARA LA ADMINISTRACION PUBLICA
            </span>
          </div>

          <form
            autocomplete="off"
            autoComplete="off"
            onSubmit={onSubmit}
            class="login100-form validate-form"
          >
            <div className="login100-form-title">
              <img
                src={op.imagenes + "/imagen?img=" + op.logologin}
                alt="logo"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
            <div
              class="wrap-input100 validate-input"
              data-validate="Valid email is required: ex@abc.xyz"
            >
              <input
                class="input100"
                autoFocus
                ref={txtUserName}
                placeholder="Usuario"
                type="text"
                id="usuario_siap"
                required
                name="usuario_siap"
                autoComplete="off"
                /*value={values.username}*/ onKeyPress={(event) => {
                  if (event.which === 13) {
                    txtPassword.current.focus();
                  }
                }}
              /*onChange={onChange}*/
              />
              <span class="focus-input100"></span>
              <span class="symbol-input100">
                <i class="fa fa-envelope" aria-hidden="true"></i>
              </span>
            </div>

            <div
              class="wrap-input100 validate-input"
              data-validate="Password is required"
            >
              <input
                class="input100"
                ref={txtPassword}
                type="text"
                placeholder="Contraseña"
                name="clave_siap"
                id="clave_siap"
                autoComplete="new-password"
                required /*value={values.password}*/
                /*onChange={onChange}*/ value={mask.repeat(pass.length)}
                onChange={updatePass}
              />

              <span class="focus-input100"></span>
              <span class="symbol-input100">
                <i class="fa fa-lock" aria-hidden="true"></i>
              </span>
            </div>

            <div class="container-login100-form-btn">
              <button type="submit" value="Ingresar" class="login100-form-btn">
                Ingresar
              </button>
            </div>

            <div class="text-center p-t-12"></div>

            <div class="text-center p-t-136"></div>
          </form>
        </div>
      </div>

      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />

      <Dimmer active={loading} inverted></Dimmer>
    </main>
  );
}

export default Login;

{
  /* <section className="baner">
      <div className="baner-content">

        <div className="boder text-center" >
          <div className="col-12 user-img">
            <img src={op.imagenes + '/imagen?img=Logopsiap.png'} alt="" />
          </div>
          <div className="divLogin">
            <form className="col-12" onSubmit={onSubmit} >
              <div className="form-group" id="user-group">
                <input autoFocus ref={txtUserName} type="text" autoComplete="off" className="inputLogin" required placeholder="Usuario:" name="username" value={values.username}
                  onKeyPress={(event) => {
                    if (event.which === 13) {
                      txtPassword.current.focus();
                    }
                  }}
                  onChange={onChange} />
              </div>
              <div className="form-group" id="contrasena-group">
                <input ref={txtPassword} type="password" autoComplete="off" className="inputLogin" required placeholder="Contraseña:" name="password" value={values.password}
                  onChange={onChange} />
              </div>
              <button type="submit" className="buttonLogin"><i className="fas fa-sign-in-alt"> Ingresar</i></button>

            </form>

          </div>
        </div>
        <Mensaje titulo={titulo} mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa} />

       <Dimmer active={activate} >
        </Dimmer>
      </div>
    </section>
 */
}
